import { action, computed, observable } from 'mobx';
import { utils } from '../utils/common';

type PageType = 'splash' | 'setup' | 'lobby' | 'join' | 'waiting' | 'game';

export type ConsoleLogType = 'log' | 'info' | 'warn' | 'error' | 'debug';

export interface ConsoleMessage {
    id: string;
    type: ConsoleLogType;
    args: any[];
    timestamp: Date;
}

class QrCodeModalState extends utils.WithMobXAction {
    @observable accessor copied: boolean = false;
}

class ModalsState extends utils.WithMobXAction {
    readonly qrCodeModal = new QrCodeModalState();

    @computed
    get isUserSetupModalFormValid(): boolean {
        return appLocalStore.userName.trim() !== '' && appLocalStore.userAvatar !== null;
    }
}



class WaitingPageStore extends utils.WithMobXAction {
    @observable accessor copyToClipboardClicked: boolean = false;
    @observable accessor showQrModal: boolean = false;
}

class ConsolePanel extends utils.WithMobXAction {

    // Console Panel state
    @observable accessor visible: boolean = true;
    @observable accessor messages: ConsoleMessage[] = [];
    @observable accessor panelHeight: number = 25; // percentage of screen height

    @action
    toggleAction() {
        this.visible = !this.visible;
    }

    @action
    addMessageAction(message: ConsoleMessage) {
        this.messages.push(message);
    }

    @action
    clearMessagesAction() {
        this.messages = [];
    }

    @action
    setHeightAction(height: number) {
        this.panelHeight = Math.max(10, Math.min(90, height)); // Clamp between 10% and 90%
    }
}

class AppLocalStore extends utils.WithMobXAction {

    @observable accessor userId: string = "";
    @observable accessor userName: string = "";
    @observable accessor userAvatar: string | null = null;

    @observable accessor currentPage: PageType = "splash";
    @observable accessor errors: string[] = [];
    @observable accessor isHost: boolean | null = null;



    pages = {
        waiting: new WaitingPageStore() as Readonly<WaitingPageStore>,
    }

    debug = {
        console: new ConsolePanel() as Readonly<ConsolePanel>,
    }

    readonly modals = new ModalsState();

    @action
    addErrorAction(error: string) {
        this.errors.push(error);
    }

    @action
    dismissErrorAction(index: number) {
        this.errors.splice(index, 1);
    }

    @action
    navigateToPage(page: PageType) {
        this.currentPage = page;
    }
}

export const appLocalStore = new AppLocalStore() as Readonly<AppLocalStore>;

